import React from 'react';
import './Logo.css';

const VARIANTS = {
  nav: { iconHeight: 34, wordmarkSize: 24, letterSpacing: '-0.8px', gap: 12 },
  footer: { iconHeight: 22, wordmarkSize: 17, letterSpacing: '-0.5px', gap: 9 },
  hero: { iconHeight: 78, wordmarkSize: 56, letterSpacing: '-2px', gap: 22 },
};

export default function Logo({ variant = 'nav', showWordmark = true, onLight = false, className = '' }) {
  const { iconHeight, wordmarkSize, letterSpacing, gap } = VARIANTS[variant] ?? VARIANTS.nav;
  const iconWidth = Math.round((iconHeight * 72) / 56);
  const ink = onLight ? '#0A0A0C' : '#FFFDFB';

  return (
    <div className={`brand-logo ${className}`} style={{ gap }}>
      <svg width={iconWidth} height={iconHeight} viewBox="0 0 72 56" fill="none" aria-hidden="true">
        <path d="M14 46 V24 Q14 14 24 14 H28" stroke={ink} strokeWidth="9" strokeLinecap="round" />
        <path d="M36 17 L49 30 L36 43" stroke="#E5382B" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M50 17 L63 30 L50 43" stroke="#E5382B" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
      </svg>
      {showWordmark && (
        <span
          className="brand-wordmark"
          style={{ color: ink, fontSize: wordmarkSize, letterSpacing }}
        >
          roon<span className="brand-wordmark-accent">bash</span>
        </span>
      )}
    </div>
  );
}
